export const formatPrice = (price) => {
  return new Intl.NumberFormat('es-CO', {
    style: 'currency',
    currency: 'COP',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(price);
};

export const formatArea = (area) => {
  return `${area} m²`;
};

export const getPropertyTypeLabel = (type) => {
  const labels = {
    APARTMENT: 'Apartamento',
    HOUSE: 'Casa',
    LOT: 'Lote',
    FARM: 'Finca',
    OFFICE: 'Oficina',
    LOCAL: 'Local Comercial',
  };
  return labels[type] || type;
};

export const getOperationLabel = (operation) => {
  return operation === 'SALE' ? 'Venta' : 'Arriendo';
};

export const getStatusLabel = (status) => {
  const labels = {
    DRAFT: 'Borrador',
    PENDING: 'Pendiente',
    APPROVED: 'Aprobado',
    REJECTED: 'Rechazado',
  };
  return labels[status] || status;
};

export const getStatusColor = (status) => {
  const colors = {
    DRAFT: 'bg-slate-100 text-slate-700',
    PENDING: 'bg-amber-100 text-amber-700',
    APPROVED: 'bg-secondary-light text-secondary',
    REJECTED: 'bg-red-100 text-red-700',
  };
  return colors[status] || 'bg-slate-100 text-slate-700';
};